import { Download, Monitor, Smartphone, Pencil, Send, Users, Code2 } from "lucide-react";

export const PreviewToolbar = ({ device, setDevice, editing, setEditing, onCode, onDownload, onSend, onBulk, bulkAllowed }) => (
  <div data-testid="preview-toolbar" className="flex flex-wrap items-center gap-3 px-6 py-3 border-b border-border">
    <div className="inline-flex rounded-full border border-border p-0.5 bg-secondary/50">
      <button data-testid="device-desktop" onClick={() => setDevice("desktop")}
        className={`p-1.5 px-3 rounded-full ${device === "desktop" ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>
        <Monitor size={14} />
      </button>
      <button data-testid="device-mobile" onClick={() => setDevice("mobile")}
        className={`p-1.5 px-3 rounded-full ${device === "mobile" ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>
        <Smartphone size={14} />
      </button>
    </div>
    <div className="ml-auto flex items-center gap-2">
      <button data-testid="edit-toggle-btn" onClick={() => setEditing(!editing)}
        className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold border transition-colors ${
          editing
            ? "bg-accent text-accent-foreground border-accent"
            : "border-border hover:bg-secondary"
        }`}>
        <Pencil size={13} /> {editing ? "Editing on" : "Edit content"}
      </button>
      <button data-testid="html-code-btn" onClick={onCode}
        className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-xs font-semibold hover:bg-secondary transition-colors">
        <Code2 size={13} /> HTML code
      </button>
      <button data-testid="download-html-btn" onClick={onDownload}
        className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-xs font-semibold hover:bg-secondary transition-colors">
        <Download size={13} /> Download
      </button>
      <button data-testid="send-email-btn" onClick={onSend}
        className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-4 py-2 text-xs font-semibold hover:opacity-90 transition-opacity">
        <Send size={13} /> Send
      </button>
      <button data-testid="bulk-send-open-btn" onClick={onBulk} disabled={!bulkAllowed}
        title={bulkAllowed ? "Send to your client list from CSV/Excel" : "One-to-one/transactional template — bulk sending disabled"}
        className="inline-flex items-center gap-2 rounded-full bg-accent text-accent-foreground px-4 py-2 text-xs font-semibold hover:opacity-90 transition-opacity disabled:opacity-40 disabled:cursor-not-allowed">
        <Users size={13} /> Bulk
      </button>
    </div>
  </div>
);
